import PropTypes from 'prop-types';
import React from 'react';

import {
  convertApiMaskToIMask,
  selectBankIntoList
} from '../../../services/bank';
import {IMaskInputWrapper} from '../../../shared/components/IMaskInputWrapper';
import {useChatStore} from '../../../store/slices/chatStore';

const BankAccountInput = (props) => {
  const bankObject = useChatStore((state) => state.bankObject);
  const banksList = useChatStore((state) => state.banksList);

  const getMaskAccountInput = () => {
    const bankSelected = selectBankIntoList(bankObject, banksList);
    return convertApiMaskToIMask(bankSelected);
  };

  return (
    <IMaskInputWrapper
      data-testid="bank-account-input"
      className="input-message"
      type="text"
      name="message"
      id="message"
      onChange={props.onChange}
      mask={getMaskAccountInput()}
      lazy={true}
      autoComplete="off"
      placeholder="Digite a sua conta bancária com dígito. Exemplo: 99999-9"
    />
  );
};

BankAccountInput.propTypes = {
  onChange: PropTypes.func
};

export default BankAccountInput;
